import React from 'react';
import './Process.css';

export const process_steps = [
    "Расчёт в калькуляторе",
    "Связь с оператором",
    "Встреча в офисе",
    "Обмен"
];

const Process = () => {
    return (
        <div className={'process-wrapper card'}>

            <h2 className={'uppercase'} style={{marginTop: '2px', marginBottom: '-2px'}}>
                Процесс Сделки
            </h2>

            <div className={'process-container'}>

                {process_steps.map((step, stepIndex) =>
                    <div className={'process-item'}>

                        <h4 className={'uppercase black'}>
                            {step}
                        </h4>

                        <span className={'process-number'}>
                            {stepIndex + 1}
                        </span>

                    </div>
                )}

            </div>

        </div>
    );
};

export default Process;